import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";

export const getMarketPlaceNamesRoutine = createRoutine(
  "dfuse/GET_MARKETPLACE_NAMES"
);
export const getPartnersRoutine = createRoutine("dfuse/GET_PARTNERS");
export const getBidnameAuctionDataRoutine = createRoutine(
  "dfuse/GET_BIDNAME_AUCTION_DATA"
);
